import httpService from '@/services/httpService'

export const types = {
  SET_STATUSES: 'status/SET_STATUS',
  SET_SETTINGS: 'status/SET_SETTINGS'
}

const state = {
  statuses: [],
  settings: {
    fk_pivot_field: [],
    fk_pivot_table: [],
    is_active: []
  }
}

const mutations = {
  [types.SET_STATUSES]: function (state, statuses) {
    state.statuses = statuses
  },
  [types.SET_SETTINGS]: function (state, settings) {
    state.settings = settings
  }
}

const actions = {
  validate: async function (store, params) {
    const response = await httpService.get(`/status/validate`, { params })
    if (!response) {
      return {}
    }
    return response.data
  },
  getStatusData: async function ({ commit }, params) {
    const response = await httpService.get('/status', { params })
    if (!response || !response.data) {
      return []
    }
    commit(types.SET_STATUSES, response.data)
    return response.data
  },
  createStatus: function (store, params) {
    return httpService.post('/status', params,
      { successMessage: 'Status successfully created', raiseError: true, cancelErrorMessage: true })
  },
  updateStatus: function (store, params) {
    return httpService.patch('/status', params,
      { successMessage: 'Status successfully updated', raiseError: true, cancelErrorMessage: true })
  },
  removeStatus: function (store, params) {
    return httpService.delete('/status', {
      params,
      successMessage: 'Status successfully removed',
      raiseError: true,
      cancelErrorMessage: true
    })
  },
  getStatusSettings: async function ({ commit }) {
    const response = await httpService.get('/status/settings')
    if (!response || !response.data) {
      return
    }
    commit(types.SET_SETTINGS, response.data)
    return response.data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
